import { Link } from "react-router-dom";
import { DesktopNav } from "./navbar/DesktopNav";
import { useEffect, useState } from "react";
import { MobileNav } from "./navbar/MobileNav";
import { MobileMenu } from "./navbar/MobileMenu";

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? "navbar-glass py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="container px-4 mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src="/igbanwo-logo.png" alt="Igbanwo Logo" className="h-10" />
        </Link>

        {/* Desktop Navbar */}
        <DesktopNav />

        {/* Mobile menu Button */}
        <MobileMenu isOpen={isMenuOpen} onClick={toggleMenu} />
      </div>
      {/* Mobile Navbar */}
      <MobileNav isOpen={isMenuOpen} onToggle={toggleMenu} />
    </header>
  );
};
